export default __webpack_public_path__ + "static/media/2.18cc0cfa.png";